import { URL_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { DataTransformFn } from '../../../bulk-edit-transform/types.tsx';
import type { jiraUrlFieldFragment as JiraUrlField } from '../fragment/__generated_apollo__/jiraUrlFieldFragment.ts';

export const transformUrlFieldForOptimisticUpdates: DataTransformFn<JiraUrlField, string | null> = (
	existingField: JiraUrlField,
	fieldData: string | null,
): JiraUrlField => ({
	...existingField,
	uri: !fieldData ? null : fieldData,
});

export const urlOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<JiraUrlField, string | null>;
} = {
	[URL_CF_TYPE]: transformUrlFieldForOptimisticUpdates,
};
